module.exports = __webpack_public_path__ + "static/sala2-6dda762281551559978fe34e01ce41d6.jpg";